import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OpentokModule} from "ng2-opentok/dist/opentok.module";
import { VideoCallWidgetComponent } from '@app/tokbox/components/video-call-widget/video-call-widget.component';
import { LoadingComponent } from '@app/tokbox/components/loading/loading.component';
import { ModalModule } from 'ngx-bootstrap';
import { FormsModule } from '@angular/forms';
import { environment } from '@env/environment';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    OpentokModule.forRoot({apiKey: environment.TOKBOX_KEY})
  ],
  declarations: [
    VideoCallWidgetComponent,
    LoadingComponent,
    VideoCallWidgetComponent
  ],
  exports:[
    VideoCallWidgetComponent,
    LoadingComponent,
    VideoCallWidgetComponent
  ]
})
export class TokboxModule { 
 
}



// WEBPACK FOOTER //
// ./src/app/tokbox/tokbox.module.ts